var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEastWestMounting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 282,
    height: 69.299,
    viewBox: "0 0 282 69.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mot",
    transform: "translate(11174 10077.598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180",
    transform: "translate(3875.809 -445.711)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_673",
    "data-name": "Line 673",
    y2: 57.333,
    transform: "translate(-14964.705 -9620.92)",
    fill: "none",
    stroke: "#b7dc8f",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_672",
    "data-name": "Line 672",
    y2: 51.953,
    transform: "translate(-14996.984 -9615.54)",
    fill: "none",
    stroke: "#b7dc8f",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_673-2",
    "data-name": "Line 673",
    y2: 51.953,
    transform: "translate(-14826.173 -9615.54)",
    fill: "none",
    stroke: "#b7dc8f",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_672-2",
    "data-name": "Line 672",
    y2: 57.333,
    transform: "translate(-14858.452 -9620.92)",
    fill: "none",
    stroke: "#b7dc8f",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_668",
    "data-name": "Line 668",
    x2: 121.048,
    transform: "matrix(0.985, 0.174, -0.174, 0.985, -14898.376, -9628.99)",
    fill: "none",
    stroke: "#1d3c34",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_670",
    "data-name": "Line 670",
    x2: 121.048,
    y2: 0.001,
    transform: "matrix(-0.985, 0.174, -0.174, -0.985, -14921.24, -9628.989)",
    fill: "none",
    stroke: "#1d3c34",
    strokeLinecap: "round",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_680",
    "data-name": "Line 680",
    x1: 280,
    transform: "translate(-11173 -10009.299)",
    fill: "none",
    stroke: "#1d3c34",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEastWestMounting);
export default __webpack_public_path__ + "static/media/east_west_mounting.acda748689b87e34f5ec3a58906641ec.svg";
export { ForwardRef as ReactComponent };